var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st00{fill:#FFFFFF;}\n\t.st01{fill:#2775C9;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st00",
    cx: 16,
    cy: 16.1,
    r: 14.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st01",
    d: "M31.4,16.1c0,8.4-6.8,15.4-15.4,15.4C6.7,31.3,0.4,23.6,0.7,15.7C0.8,7.4,7.7,0.5,16.2,0.5 C24.5,0.5,31.4,7.5,31.4,16.1z M12.8,18.2c-1.2,0-1.4,0.3-1,1.2c0.4,1.1,1.2,1.9,2.3,2c0.8,0.1,1.1,0.5,1,1.4 c-0.1,0.7,0.1,1,0.8,1c1,0,1.1-0.1,1.1-1.1c0-0.4-0.1-0.8,0.5-1.1c1.8-0.4,2.7-1.8,2.6-3.5c-0.1-1.6-1-2.6-2.9-3 c-0.8-0.1-1.5-0.3-2.3-0.4c-0.7-0.1-1.1-0.7-1.1-1.4c0-0.8,0.5-1.2,1.2-1.4c1.2-0.3,2,0.1,2.7,1.2c0.3,0.4,1.2,0.7,1.6,0.4 c0.5-0.3,0.3-0.7,0.1-1.1c-0.3-0.8-1-1.5-1.8-1.8c-0.8-0.3-1-0.7-1-1.4c0.1-0.7-0.3-1-1-1c-0.8,0-1.1,0.3-1,1.1 c0.1,0.7-0.1,1-0.8,1.2c-1.5,0.3-2.3,1.5-2.3,3.1c0.1,1.5,1,2.5,3,2.9c0.8,0.1,1.6,0.1,2.3,0.5c1.1,0.4,1.4,1.5,0.7,2.3 c-0.8,1.1-3.7,1-4.1-0.5C13.6,18.4,13.4,18.1,12.8,18.2z M13.1,6.1c0-1.2-0.1-1.2-1.2-0.8c-6.1,2.3-9.1,9.3-6.5,15.4 c1.4,3.1,3.5,5.2,6.8,6.4c0.4,0.1,0.7,0.3,1-0.1c0.3-0.7,0-1.5-0.8-1.9c-3.8-1.8-5.9-4.6-5.9-8.9s2.2-7.1,5.9-8.9 C13,6.9,13.2,6.8,13.1,6.1z M27.5,16.1c0-4.8-2.9-9-7.4-10.8c-1.2-0.5-1.4-0.4-1.4,1c0,0.7,0.4,0.8,1,1.1c6.4,2.7,7.8,11,2.7,15.8 c-1,0.8-1.9,1.5-3.1,1.9c-0.5,0.3-0.8,1.2-0.5,1.8c0.3,0.7,0.8,0.3,1.2,0.1C24.5,25.2,27.5,21,27.5,16.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.95d4c4e0.svg";
export { ForwardRef as ReactComponent };